import React from 'react';
import { AppRouter } from '@routing';

const App = () => <AppRouter />;

export default App;
